module.exports = __webpack_public_path__ + "img/small-9.da4d552e.jpg";